import { lazy, Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import Layout from "./components/layout/Layout";
import PrivateRoute from "./components/layout/PrivateRoute";
// Eager — small pages loaded upfront
import Home from "./pages/Home";
import Shop from "./pages/Shop";
import Cart from "./pages/Cart";
import Login from "./pages/Login";
import Register from "./pages/Register";
import NotFound from "./pages/NotFound";
// Lazy — heavy or rarely-visited pages
const Product = lazy(() => import("./pages/Product"));
const Category = lazy(() => import("./pages/Category"));
const Checkout = lazy(() => import("./pages/Checkout"));
const OrderSuccess = lazy(() => import("./pages/OrderSuccess"));
const MyAccount = lazy(() => import("./pages/MyAccount"));
const Contact = lazy(() => import("./pages/Contact"));

function LazyFallback() {
    return (
        <div className="flex items-center justify-center min-h-[50vh]">
            <div className="w-8 h-8 border-4 border-primary-200 border-t-primary-600 rounded-full animate-spin" />
        </div>
    );
}

function App() {
    return (
        <Routes>
            <Route path="/" element={<Layout />}>
                <Route index element={<Home />} />
                <Route path="shop" element={<Shop />} />
                <Route path="cart" element={<Cart />} />
                <Route path="login" element={<Login />} />
                <Route path="register" element={<Register />} />
                <Route path="shop/:slug" element={
                    <Suspense fallback={<LazyFallback />}><Product /></Suspense>
                } />
                <Route path="category/:slug" element={
                    <Suspense fallback={<LazyFallback />}><Category /></Suspense>
                } />
                <Route path="contact" element={
                    <Suspense fallback={<LazyFallback />}><Contact /></Suspense>
                } />
                <Route path="order-success/:orderId" element={
                    <Suspense fallback={<LazyFallback />}><OrderSuccess /></Suspense>
                } />
                <Route element={<PrivateRoute />}>
                    <Route path="checkout" element={
                        <Suspense fallback={<LazyFallback />}><Checkout /></Suspense>
                    } />
                    <Route path="my-account" element={
                        <Suspense fallback={<LazyFallback />}><MyAccount /></Suspense>
                    } />
                    <Route path="my-account/orders" element={
                        <Suspense fallback={<LazyFallback />}><MyAccount defaultTab="orders" /></Suspense>
                    } />
                    <Route path="my-account/profile" element={
                        <Suspense fallback={<LazyFallback />}><MyAccount defaultTab="profile" /></Suspense>
                    } />
                    <Route path="my-account/address" element={
                        <Suspense fallback={<LazyFallback />}><MyAccount defaultTab="address" /></Suspense>
                    } />
                </Route>
                <Route path="*" element={<NotFound />} />
            </Route>
        </Routes>
    );
}

export default App;
